import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import CommentBoxLayout from '../../../../layouts/CommentBoxLayout';
import CommentBoxAvatar from '../../../../lego/CommentBoxAvatar';
import CommentForAnonymous from '../../../../../CommentForAnonymous';
const AnonymousView = ()=>{
    const isMobile = useContext(MobileContext);
    return /*#__PURE__*/ React.createElement(CommentBoxLayout, {
        avatar: !isMobile && /*#__PURE__*/ React.createElement(CommentBoxAvatar, {
            withLink: false
        }),
        content: /*#__PURE__*/ React.createElement(CommentForAnonymous, null)
    });
};
AnonymousView.displayName = 'AnonymousView';
export default AnonymousView;

//# sourceMappingURL=AnonymousView.js.map